var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6667 6.50008H0V2.16675H21.6667V6.50008ZM17.3333 10.8334H0V15.1667H17.3333V10.8334ZM13 19.5001H0V23.8334H13V19.5001ZM26 2.16675V10.8334H21.6667V19.5001H17.3333V28.1667H0V39.0001H32.5V8.66675C32.5 5.08308 29.5837 2.16675 26 2.16675ZM42.25 49.8334C45.2422 49.8334 47.6667 47.4089 47.6667 44.4167C47.6667 44.0441 47.6147 43.6844 47.541 43.3334H36.9568C36.8832 43.6844 36.8312 44.0441 36.8312 44.4167C36.8312 47.4089 39.2578 49.8334 42.25 49.8334ZM11.9145 49.8334C14.9067 49.8334 17.3312 47.4089 17.3312 44.4167C17.3312 44.0441 17.2792 43.6844 17.2055 43.3334H6.62567C6.552 43.6844 6.5 44.0441 6.5 44.4167C6.5 47.4089 8.92233 49.8334 11.9145 49.8334ZM36.8333 39.0001H52V28.1667H36.8333V39.0001ZM41.1667 10.8334H36.8333V23.8334H52V21.6667C52 15.6932 47.1402 10.8334 41.1667 10.8334Z",
    fill: "#660066"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.8d7180bb15744ec14cbf83f75ebc7330.svg";
export { ForwardRef as ReactComponent };